import type { Slots } from '@types'

export function filterSlots(data: Slots) {
  const entries = Object.entries(data)

  const enabledSlots = Object.fromEntries(
    entries.filter(([_, slotArr]) => slotArr.some((slot) => slot.team !== 'Booked'))
  )
  const disabledDates = entries
    .filter(([_, slotArr]) => slotArr.every((slot) => slot.team === 'Booked'))
    .map(([date]) => new Date(date))

  return { enabledSlots, disabledDates }
}
